import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { IndicatorLayoutValueBar, SegmentBar } from '@shapeable/ui';
import { IndicatorLayoutComponentProps } from '../../types';
import { KELP_HEALTH_COLOUR_MAP } from '../../data';

const cls = classNames('indicator-layout-kelp-condition-bar');

/** Scored condition is 1–4 on a four-segment bar. 0 means insufficient evidence (NEI). */
const CONDITION_BAR_MAX = 4;

export type IndicatorLayoutKelpConditionBarProps = IndicatorLayoutComponentProps;

const RowStyles = breakpoints({
  base: css`
    font-size: 1em;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: ${theme.UNIT(4)};
  `,
});

const TitleStyles = breakpoints({
  base: css`
    width: 50%;
    font-weight: 400;
    font-size: 1em;
    padding-right: ${theme.UNIT(4)};
    box-sizing: border-box;
    margin: 0;
  `,
});

const ChartStyles = breakpoints({
  base: css`
    width: 50%;
  `,
});

const My = {
  Row: styled.div`${RowStyles}`,
  Title: styled.h3`${TitleStyles}`,
  Chart: styled(SegmentBar)`${ChartStyles}`,
};

export const IndicatorLayoutKelpConditionBar: Shapeable.FC<IndicatorLayoutKelpConditionBarProps> = (props) => {
  const { entity } = props;
  const { result } = entity || {};
  const { numericValue, indicator } = result || {};
  const title = indicator?.title || indicator?.name;

  if (numericValue === 0) {
    return (
      <My.Row className={cls.name()}>
        <My.Title>{title}</My.Title>
        <My.Chart
          value={CONDITION_BAR_MAX}
          maxValue={CONDITION_BAR_MAX}
          color={KELP_HEALTH_COLOUR_MAP[0]}
        />
      </My.Row>
    );
  }

  return <IndicatorLayoutValueBar entity={entity} />;
};

IndicatorLayoutKelpConditionBar.cls = cls;
